import {redirect} from 'react-router-dom';
import './style/index.less';
import Root from './routes/root';
import FailurePage from './routes/failure-page';
import SwitchTeamPage from './routes/switch-team-page';
import {
  FAILURE_SAML,
  FAILURE_AUTH_APP,
  FAILURE_PAGE_NOT_FOUND,
  FAILURE_SAML_LIMIT_REACHED,
} from './constants/errors';
import SamlRedirectForm from './routes/saml-redirect-form';
import OauthAuthorizeForm from './routes/oauth-authorize-form';
import {ROUTE_PREFIX} from './redesign/routes/new-routes';

// Redirect map: legacy path → new path (uses ROUTE_PREFIX for easy prefix swap)
const LEGACY_REDIRECTS = {
  '/': ROUTE_PREFIX,
  '/login': ROUTE_PREFIX,
  '/signin': ROUTE_PREFIX,
  '/signup': `${ROUTE_PREFIX}/signup`,
  '/signup/form': `${ROUTE_PREFIX}/signup`,
  '/verify-email': `${ROUTE_PREFIX}/signup/verify-email`,
  '/success': `${ROUTE_PREFIX}/success`,
  '/billing': `${ROUTE_PREFIX}/signup/billing`,
  '/billing-success': ROUTE_PREFIX,
  '/forgot-password': `${ROUTE_PREFIX}/forgot-password`,
  '/reset-password': `${ROUTE_PREFIX}/forgot-password/set-password`,
  '/reset-password-success': `${ROUTE_PREFIX}/forgot-password/success`,
  '/pro': `${ROUTE_PREFIX}/change-plan`,
  '/pro/upgrade': `${ROUTE_PREFIX}/change-plan/upgrade`,
  '/team-member/signup': ROUTE_PREFIX,
  '/team-member/confirm-password': ROUTE_PREFIX,
  '/failure-general': `${ROUTE_PREFIX}/error`,
  '/request-error': `${ROUTE_PREFIX}/error`,
};

const createRedirectLoader =
  (to) =>
  ({request}) => {
    const url = new URL(request.url);
    return redirect(`${to}${url.search}${url.hash}`);
  };

const redirectRoutes = Object.entries(LEGACY_REDIRECTS).map(([from, to]) => ({
  path: from,
  loader: createRedirectLoader(to),
}));

const paramRedirectRoutes = [
  {
    path: '/join-team/:invitationCode',
    loader: ({params, request}) => {
      const url = new URL(request.url);
      return redirect(
        `${ROUTE_PREFIX}/team-member/${params.invitationCode}${url.search}${url.hash}`
      );
    },
  },
  {
    path: '/join-event/:invitationCode',
    loader: ({params, request}) => {
      const url = new URL(request.url);
      return redirect(
        `${ROUTE_PREFIX}/collaborator/${params.invitationCode}${url.search}${url.hash}`
      );
    },
  },
];

export const legacyRoutes = [
  ...redirectRoutes,
  ...paramRedirectRoutes,
  {
    element: <Root />,
    errorElement: <FailurePage type={FAILURE_PAGE_NOT_FOUND} />,
    children: [
      {
        path: '/saml/:idpName',
        element: <SamlRedirectForm />,
      },
      {
        path: '/saml-error',
        element: <FailurePage type={FAILURE_SAML} />,
      },
      {
        path: '/saml-overage',
        element: <FailurePage type={FAILURE_SAML_LIMIT_REACHED} />,
      },
      {
        path: '/oauth/authorize',
        element: <OauthAuthorizeForm />,
      },
      {
        path: '/oauth-authorize-error',
        element: <FailurePage type={FAILURE_AUTH_APP} />,
      },
      {
        path: '/switch-team/:invitationCode',
        element: <SwitchTeamPage />,
      },
    ],
  },
  // Catch-all: redirect any unmatched non-/new path to the new home
  {
    path: '*',
    loader: createRedirectLoader(ROUTE_PREFIX),
  },
];
